export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      title: 'Sign Up & Configure',
      description: 'Create your account in minutes and customize your AI receptionist with your business information, greeting messages, and scheduling preferences.',
      icon: 'ri-user-settings-line'
    },
    {
      number: '2',
      title: 'Connect Your Systems',
      description: 'Integrate seamlessly with your existing calendar, CRM, and phone system. Our setup wizard makes it easy with step-by-step guidance.',
      icon: 'ri-plug-line'
    },
    {
      number: '3',
      title: 'Go Live & Grow',
      description: 'Activate your AI receptionist and start handling calls immediately. Monitor performance, gather insights, and watch your business scale effortlessly.',
      icon: 'ri-rocket-line'
    }
  ];

  return (
    <section id="how-it-works" className="relative py-24 overflow-hidden">
      {/* Diagonal Split Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-white via-purple-50 to-pink-50 transform -skew-y-3 origin-top-left"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-20">
          <p className="text-xs font-bold tracking-widest text-purple-600 uppercase mb-4">
            HOW IT WORKS
          </p>
          <h2 className="text-5xl font-bold text-gray-900">
            Get Started in Three Simple Steps
          </h2>
        </div>

        {/* Steps Container */}
        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Connecting Lines */}
          <div className="hidden md:block absolute top-20 left-0 right-0 h-1">
            <div className="max-w-5xl mx-auto relative h-full">
              <div className="absolute left-1/4 right-1/4 top-0 border-t-2 border-dashed border-purple-300"></div>
            </div>
          </div>

          {steps.map((step, index) => (
            <div 
              key={index}
              className="relative bg-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              {/* Step Number */}
              <div className="absolute -top-6 -left-6 w-16 h-16 bg-gradient-to-br from-purple-600 to-pink-600 rounded-2xl flex items-center justify-center shadow-lg">
                <span className="text-3xl font-bold text-white">{step.number}</span>
              </div>

              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center mb-6 mt-4">
                <i className={`${step.icon} text-5xl text-purple-600`}></i>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {step.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed text-base">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
